<template>
  <div class="select-part " :class="{ 'up': !defaultShow }">
    <div class="title" @click="hideSlect">
      <h3>{{ title }}</h3>
      <span class="iconfont icon-arrow-up"></span>
    </div>
    <div class="select-item" :class="row.class">
      <template v-for="(item, index) in dropList">
        <div class="firstItem" :key="index" :class="{ 'active': row.value && row.value == item.id }" @click="changeSlectItem([item.id], row.value && row.value == item.id)">
          {{ item.name }}
        </div>
        <template v-if="item.children && item.children.length > 0">
          <div class="second-list" :class="'slist' + index" v-show="row.value && row.value == item.id">
            <template v-if="item.thirdLevel">
              <div class="third-list" v-for="(subitem, subindex) in item.children" :key="`sub_${subindex}`">
                <em>{{ subitem.name }}</em>
                <p>
                  <span
                    v-for="(subSitem, sbsIndex) in subitem.children" 
                    :key="`subs_${sbsIndex}`" 
                    :class="{ 'active': subitem.value && subitem.value == subSitem.id }"
                    @click="changeSlectItem([item.id,subSitem.id], subitem.value && subitem.value == subSitem.id)"
                  >
                    {{ subSitem.name }}
                  </span>
                </p>
              </div>
            </template>
            <template v-else>
              <span 
                v-for="(subitem, subindex) in item.children" 
                :key="`sub_${subindex}`"
                :class="{ 'active': item.value && item.value == subitem.id }"
                @click="changeSlectItem([item.id,subitem.id], item.value && item.value == subitem.id)" 
              >
                {{ subitem.name }}
              </span>
            </template>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slideDrop',
  props: {
    index: String|Number,
    row: Object,
    base: Array
  },
  computed: {
    title() {
      const row = this.row || {}
      return row.name || ''
    },
    dropList() {
      const row = this.row || {}
      return row.children || []
    },
    defaultShow() {
      const row = this.row || {}
      return row.isShow
    },
    listClass() {
      const row = this.row || {}
      return row.class || ''
    },
  },
  data() {
    return {
    }
  },
  methods: {
    hideSlect() {
      this.$emit("changeCol", this.index)
    },
    changeSlectItem(ids, isActive) {
      if (isActive) {
        ids.splice(ids.length - 1, 1)
      }
      this.$emit('change', {ids: ids.join(','), index: this.index})
    },
    chooseProgramSec(row) {
    }
  },
}
</script>